import gql from 'graphql-tag';

const UPDATE_USER_CITY_MUTATION = gql`
  mutation updateUserCity($cityId: Int) {
    updateUserCity(cityId: $cityId) {
      id
      subscribedCityIds
    }
  }
`;
export default UPDATE_USER_CITY_MUTATION;
